/* Component in the Callsheet2 component to display the Callsheet 
   Walkies 2 info */
import React, { useEffect, useState } from "react"
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../../styles/Callsheets.module.css";
import { axiosInstance, axiosReq } from "../../../api/axiosDefaults"
import { CLIENT_PROGRAM_HOSTNAME } from "../../../utils/config"
import useHostName from "../../../hooks/useHostName"
import toast from "react-hot-toast"
const emptyWalkies = {
  walkie_channel_production: "",
  walkie_channel_open: "",
  walkie_channel_transportation: "",
  walkie_channel_art_dept: "",
  walkie_channel_rollover: "",
  walkie_channel_camera: "",
  walkie_channel_electric: "",
  walkie_channel_grip: "",
}

const rowToState = (row) =>
  row
    ? {
        walkie_channel_production: row.walkie_channel_production ?? "",
        walkie_channel_open: row.walkie_channel_open ?? "",
        walkie_channel_transportation: row.walkie_channel_transportation ?? "",
        walkie_channel_art_dept: row.walkie_channel_art_dept ?? "",
        walkie_channel_rollover: row.walkie_channel_rollover ?? "",
        walkie_channel_camera: row.walkie_channel_camera ?? "",
        walkie_channel_electric: row.walkie_channel_electric ?? "",
        walkie_channel_grip: row.walkie_channel_grip ?? "",
      }
    : { ...emptyWalkies }

const WalkiesPage2 = (props ) => {
    const host = useHostName()
    const {setShow} = props;

    const [walkies, setWalkies] = useState(emptyWalkies)
      
    const {
      walkie_channel_production,
      walkie_channel_open,
      walkie_channel_transportation,
      walkie_channel_art_dept,
      walkie_channel_rollover,
      walkie_channel_camera,
      walkie_channel_electric,
      walkie_channel_grip,
    } = walkies;

    const handleMount = async () => {
      try {
        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const { data } = await axiosReq.get(`/masters/walkies/?is_second_unit=true`)
          const row = data.results?.[0]
          setWalkies(rowToState(row))
        } else {
          const response = await axiosInstance.get(
            `${localStorage.getItem("projectSlug")}/masters/walkies/?is_second_unit=true`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
              withCredentials: true,
            }
          )
          if (response?.success === false) {
            throw response.error;
          }
          const { data } = response;
          const row = data.results?.[0]
          setWalkies(rowToState(row))
        }
      } catch (err) {
        console.log(err)
        const backendError =
          err?.response?.data?.error ||
          err?.response?.data?.detail ||
          "Failed to load Walkies.";
        toast.error(backendError)
      }
    }

  useEffect(() => {
    handleMount()
  }, [])

  return (
        <div className='mt-3 mb-5'>
            <div className='d-none d-md-block mt-5'>
                <h4 className={`mt-3 pl-3 py-0 px-1 ${styles.SubTitleSpan }`} 
                style={{ textTransform: 'uppercase' }}>Walkie Channels </h4>
            </div>
            <div className='d-block d-md-none'>
            <div className={`mt-0 mb-3 text-center ${styles.SubTitleSpan }`}>
            <span className={`float-right ${styles.Close }`} onClick={() => setShow?.(false) } >Close</span> 
            <h4 className={`pl-5 text-center`} 
            style={{ textTransform: 'uppercase'}} >Walkie Channels </h4>
            </div>
            </div>
            <hr className={`mb-0 pb-0 pl-3 mt-0 pt-0 ${styles.Break5 }`}/> 
            <Row className='px-md-3'>
            <Col md={3} xs={6} className={`${styles.Border2}`}>
            <Row>
            <Col xs={9} lg={6} ><p className={`pt-1 ${styles.Walk1}`}>PRODUCTION:</p></Col>
            <Col xs={3} lg={6}><p className={` pt-1 ${styles.Walk2}`}>{walkie_channel_production}</p></Col>
            </Row>
            </Col>
            <Col md={3} xs={6} className={`${styles.Border2}`}>
            <Row>
            <Col xs={9} lg={6}><p className={`pt-1 ${styles.Walk1}`}>OPEN:</p></Col>
            <Col xs={3} lg={6}><p className={`pt-1 ${styles.Walk2}`}>{walkie_channel_open}</p></Col>
            </Row>
            </Col>
            <Col md={3} xs={6} className={`${styles.Border2}`}>
            <Row>
            <Col xs={9} lg={6}><p className={`pt-1 ${styles.Walk1}`}>ROLLOVER:</p></Col>
            <Col xs={3} lg={6}><p className={`pt-1 ${styles.Walk2}`}>{walkie_channel_rollover}</p></Col>
            </Row>
            </Col>
            <Col md={3} xs={6} className={`${styles.Border2}`}>
            <Row>
            <Col xs={9} lg={6}><p className={`pt-1 ${styles.Walk1}`}>TRANSPORT:</p></Col>
            <Col xs={3} lg={6}><p className={`pt-1 ${styles.Walk2}`}>{walkie_channel_transportation}</p></Col>
            </Row>
            </Col>
            <Col md={3} xs={6} className={`${styles.Border2}`}>
            <Row>
            <Col xs={9} lg={6}><p className={`pt-1 ${styles.Walk1}`}>ART DEPT:</p></Col>
            <Col xs={3} lg={6}><p className={`pt-1 ${styles.Walk2}`}>{walkie_channel_art_dept}</p></Col>
            </Row>
            </Col>
            <Col md={3} xs={6} className={`${styles.Border2}`}>
            <Row>
            <Col xs={9} lg={6}><p className={`pt-1 ${styles.Walk1}`}>CAMERA:</p></Col>
            <Col xs={3} lg={6}><p className={`pt-1 ${styles.Walk2}`}>{walkie_channel_camera}</p></Col>
            </Row>
            </Col>
            <Col md={3} xs={6} className={`${styles.Border2}`}>
            <Row>
            <Col xs={9} lg={6}><p className={`pt-1 ${styles.Walk1}`}>ELECTRIC:</p></Col>
            <Col xs={3} lg={6}><p className={`pt-1 ${styles.Walk2}`}>{walkie_channel_electric}</p></Col>
            </Row>
            </Col>
            <Col md={3} xs={6} className={`${styles.Border2}`}>
            <Row>
            <Col xs={9} lg={6}><p className={`pt-1 ${styles.Walk1}`}>GRIP:</p></Col>
            <Col xs={3} lg={6}><p className={`pt-1 ${styles.Walk2}`}>{walkie_channel_grip}</p></Col>
            </Row>
            </Col>
            </Row>
            <hr className={`mb-0 pl-3 mt-0 pt-1 ${styles.Break5 }`}/>
        </div>
  )
}

export default WalkiesPage2